module.exports = __webpack_public_path__ + "static/media/welcomeBonusIcon.3ba5d7d0.svg";